import React from 'react';
import { Translate as t } from '../../config/Translate';

// U-57: 필수 표시는 "(필수)" 텍스트만 쓴다(빨강 * 제거). 라벨 텍스트 바로 뒤에 붙는 단일 정의.
// 공통 입력(Inputs.js)과 공통 입력을 쓰지 않는 화면이 같은 모양을 쓰도록 공유한다.
const RequiredMark = ({ required }) => (required ? <>{' (' + t('common.label.required') + ')'}</> : null);

export default RequiredMark;
